import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["variant"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { SmallArticleCard } from './SmallArticleCard';
import { MediumArticleCard } from './MediumArticleCard';
import { LargeArticleCard } from './LargeArticleCard';
var VARIANTS_PROPS = {
  small: {
    imageWidth: 120
  },
  medium: {
    imageWidth: 350
  },
  large: {}
};
var VARIANTS = {
  small: SmallArticleCard,
  medium: MediumArticleCard,
  large: LargeArticleCard
};
export var ArticleCard = function ArticleCard(_ref) {
  var variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = VARIANTS[variant] || null;
  var extraProps = VARIANTS_PROPS[variant] || {};
  return Component ? React.createElement(Component, _extends({}, props, extraProps)) : null;
};